module.exports = __webpack_public_path__ + "static/media/near.bec57a49.mp3";